import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 60px;
  position: relative;
  
  @media (max-width: 576px) {
    margin-bottom: 40px;
  }
`;

const Title = styled.h2`
  display: inline-block;
  margin-bottom: 20px;
  position: relative;
  
  span {
    color: var(--secondary-color);
  }
`;

const Line = styled.div`
  height: 2px;
  width: 100px;
  background-color: var(--secondary-color);
  margin: 0 auto;
  position: relative;
  
  &::before, &::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--secondary-color);
  }
  
  &::before {
    left: -5px;
  }
  
  &::after {
    right: -5px;
  }
`;

const SectionHeader = ({ title, highlight, className }) => {
  const parts = title.split(highlight);
  
  return (
    <HeaderContainer className={className}>
      <Title>
        {parts[0]}<span>{highlight}</span>{parts[1]}
      </Title>
      <Line />
    </HeaderContainer>
  );
};

export default SectionHeader;
